import api from './client';

// Bank Feed Health (Diagnostics -> Integration Health). Backend:
// routes/admin_bank_feed_health.py, services/bank_feed_health.py.
export const bankFeedHealthAPI = {
  get: (params) => api.get('/admin/diagnostics/bank-feed-health', { params }),
  watchdogRuns: (limit) => api.get('/admin/diagnostics/bank-feed-health/watchdog-runs', { params: { limit } }),
  // The health payload carries each source's own manual-sync route
  // (runs in the API process, so it works even when the scheduler is down).
  triggerSync: (syncEndpoint) => api.post(syncEndpoint),
};
